import { inject, Injectable, signal, DOCUMENT } from '@angular/core';
import { SESSION_STORAGE } from '~core/providers/session-storage';

// Keep these constants in sync with the code in index.html
const DARK_THEME_CLASS_NAME = 'theme-dark--mode',
    LIGHT_THEME_CLASS_NAME = 'theme-light--mode',
    THEME_SELECTED_LOCAL_STORAGE_KEY = 'theme';

export enum Theme {
    DARK = 'dark',
    LIGHT = 'light',
}

@Injectable({
    providedIn: 'root',
})
export class ThemeManagerService {
    private readonly document = inject(DOCUMENT);
    private readonly sessionStorage: Storage | null = inject(SESSION_STORAGE);
    private readonly _themeSelected = signal<Theme>(Theme.DARK);

    readonly themeSelected = this._themeSelected.asReadonly();

    constructor() {
        const themeFromLocalStorage = this.sessionStorage?.getItem(
            THEME_SELECTED_LOCAL_STORAGE_KEY,
        ) as Theme | null;
        if (themeFromLocalStorage) {
            this.setTheme(themeFromLocalStorage);
        }
    }

    setTheme(theme: Theme): void {
        this._themeSelected.set(theme);
        this.sessionStorage?.setItem(THEME_SELECTED_LOCAL_STORAGE_KEY, this.themeSelected());
        this.setBodyClasses();
    }

    // Imposta il colore passando una stringa HEX (es. "#ff5733")
    setColor(hexPrimaryColor: string,hexHoverColor:string): void {
        console.log("Cambio colore: ",hexPrimaryColor,hexHoverColor);
        const primaryrgb = this.hexToRgbChannels(hexPrimaryColor || '#9f367f');
        const hoverrgb = this.hexToRgbChannels(hexHoverColor || '#b13e90');
        console.log("Nuovo colore: ",primaryrgb,hoverrgb);
        if (primaryrgb) {
            console.log("Colore primario: ",primaryrgb);
            // Sovrascrive la variabile CSS a livello globale
            this.document.documentElement.style.setProperty('--dynamic-primary', primaryrgb);
        }
        if (hoverrgb) {
            console.log("Colore hover: ",hoverrgb);
            // Sovrascrive la variabile CSS a livello globale
            this.document.documentElement.style.setProperty('--dynamic-hover', hoverrgb);
        }
    }

    private setBodyClasses(): void {
        const documentClassList = this.document.documentElement.classList;
        if (this.themeSelected() === Theme.DARK) {
            documentClassList.add(DARK_THEME_CLASS_NAME);
            documentClassList.remove(LIGHT_THEME_CLASS_NAME);
        } else {
            documentClassList.add(LIGHT_THEME_CLASS_NAME);
            documentClassList.remove(DARK_THEME_CLASS_NAME);
        }
    }

    private hexToRgbChannels(hex: string): string | null {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        const fullHex = hex.trim().replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);

        return result
            ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`
            : null;
    }
}